export default __webpack_public_path__ + "static/media/ttmikbooks_03.36154f88.jpg";